import { formatTablePayload } from "../../common/utils";
import {
  authClient,
  adminClient,
  feedClient,
  followClient,
} from "../../services/api/apiClient";

export const getUsesList = (tableParams, status) => {
  const data = {
    ...formatTablePayload(tableParams),
    deletedAt: status,
  };
  return authClient.post(`/users-admin`, data);
};

export const setUserHideFromDiscovery = (userId, hideFromDiscovery) =>
  authClient.put(`/users/${userId}/hide-from-discovery`, { hideFromDiscovery });

export const deleteUserAccount = (userId) =>
  adminClient.delete(`/users/${userId}`);

export const activateDeactivateUserAccount = (userId) =>
  adminClient.put(`/users/status/${userId}`, {});

export const getUserDetails = (userId) =>
  adminClient.get(`/users/${userId}`);

export const getUserPosts = (userId, page, pageSize, deletedAt = true) =>
  feedClient.get(
    `/user-posts/${userId}?page=${page}&pageSize=${pageSize}&deleteAt=${deletedAt}`
  );

export const getUserReels = (userId, page, pageSize, deletedAt = true) =>
  feedClient.get(
    `/user-reels/${userId}?page=${page}&pageSize=${pageSize}&deleteAt=${deletedAt}`
  );

export const getUserFollowList = (
  userId,
  page,
  pageSize,
  type = "follower",
  search = null
) =>
  followClient.get(
    `/user-follow-list/${userId}?page=${page}&pageSize=${pageSize}&type=${type}&search=${search}`
  );
